import { render, staticRenderFns } from "./FileWithLableDesc.vue?vue&type=template&id=cb46c54a&scoped=true&"
import script from "./FileWithLableDesc.vue?vue&type=script&lang=js&"
export * from "./FileWithLableDesc.vue?vue&type=script&lang=js&"
import style0 from "./FileWithLableDesc.vue?vue&type=style&index=0&id=cb46c54a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb46c54a",
  null
  
)

export default component.exports